import React from 'react';
import { connect } from 'react-redux';

import { Helpers } from '../../core/src/helpers';

import Link from '../../shared/components/hyperlink';

import Button from '../../ui/components/button';

import '../css/cart-button.less';

const CartButton = ({ buttonText, className, crtUrl, useAnimatedBtn, animatedBtnProps }) => {
    return useAnimatedBtn ? 
        (<Button
            {...animatedBtnProps}
            className={`cart-button ${className}`}
            linkComponent={<Link to={Helpers.decodeHtml(crtUrl)}>{buttonText}</Link>}
        />) : (
        <div className={`cart-button ${className}`}>
            <a href={Helpers.decodeHtml(crtUrl)} className="tabs-link">
                <div className="button-text">{buttonText}</div>
            </a>
        </div>
    );
};

const mapStateToProps = state => ({
    crtUrl: state.cartInfo.crtUrl,
});

export default connect(mapStateToProps, {})(CartButton);
